import { Api } from 'models/services/api';
import { UpdateOpenaiAccountQuery } from 'models/services/graphql';

import { OpenaiAccountData, OpenaiAccountDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: OpenaiAccountDataToSave;
};

const RequestQuery = `
  mutation UpdateOpenaiAccount($id: ID!, $input: UpdateOpenaiAccountInput!) {
    ${UpdateOpenaiAccountQuery}
  }
`;

type ResponseData = {
  data: {
    updateOpenaiAccount: OpenaiAccountData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: OpenaiAccountData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateOpenaiAccount;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };